import { computed, watch, type Ref } from "vue";

type UploadableAvatar = {
    file?: unknown;
    media_id?: string;
};

export function usePendingAvatarUpload(avatar: Ref<UploadableAvatar | undefined>) {
    const hasPendingUpload = computed(() => {
        return !!(avatar.value?.file && !avatar.value?.media_id);
    });

    function waitForMediaId(timeoutMs = 30000): Promise<boolean> {
        return new Promise((resolve) => {
            if (!hasPendingUpload.value) {
                resolve(true);
                return;
            }

            const timeout = setTimeout(() => {
                stopWatching();
                resolve(false);
            }, timeoutMs);

            const stopWatching = watch(
                () => avatar.value?.media_id,
                (mediaId) => {
                    if (!mediaId) return;
                    clearTimeout(timeout);
                    stopWatching();
                    resolve(true);
                },
            );
        });
    }

    return {
        hasPendingUpload,
        waitForMediaId,
    };
}
